import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { businessCoreService } from "services/BusinessCoreService";
import { Business, ContractType, Job, BusinessUnitsType } from "types";

const name: string = "business.action";

interface businessesState {
  jobs: Job[];
  loading: Boolean;
  error: string | null;
  businesses: Business[];
  businessSelected: string;
  contractTypes: ContractType[];
  businessUnitsTypes: BusinessUnitsType[];
}

const initialState: businessesState = {
  jobs: [],
  error: null,
  businesses: [],
  loading: false,
  contractTypes: [],
  businessSelected: "",
  businessUnitsTypes: [],
};

export const getBusinesses = createAsyncThunk<Business[]>(
  `${name}/GetBusiness`,
  async (): Promise<Business[]> => await businessCoreService.getBusinesses()
);

export const getJobs = createAsyncThunk<Job[]>(
  `${name}/GetJobs`,
  async (): Promise<Job[]> => await businessCoreService.getJobs()
);

export const getContractTypes = createAsyncThunk<ContractType[]>(
  `${name}/GetContractTypes`,
  async (): Promise<ContractType[]> => await businessCoreService.getContractTypes()
);

export const getBusinessUnitsType = createAsyncThunk<BusinessUnitsType[]>(
  `${name}/getBusinessUnitsType`,
  async (): Promise<BusinessUnitsType[]> => await businessCoreService.getBusinessUnitsType()
);

export const businessUnitsSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    /* BUSINESS */
    builder.addCase(getBusinesses.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getBusinesses.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.businesses = payload;
    });

    builder.addCase(getBusinesses.rejected, (state) => {
      state.loading = false;
      state.error = "error getting businesses";
    });
    /* JOBS */
    builder.addCase(getJobs.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getJobs.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.jobs = payload;
    });

    builder.addCase(getJobs.rejected, (state) => {
      state.loading = false;
      state.error = "error getting jobs";
    });
    /* CONTRACT TYPES */
    builder.addCase(getContractTypes.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getContractTypes.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.contractTypes = payload;
    });

    builder.addCase(getContractTypes.rejected, (state) => {
      state.loading = false;
      state.error = "error getting contract types";
    });
    /* BUSINESS UNITS TYPE */
    builder.addCase(getBusinessUnitsType.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getBusinessUnitsType.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.businessUnitsTypes = payload;
    });

    builder.addCase(getBusinessUnitsType.rejected, (state) => {
      state.loading = false;
      state.error = "error getting unit business type";
    });
  },
  reducers: {
    selectBusiness: (state, { payload }) => {
      state.businessSelected = payload;
    },
  },
});

export const { selectBusiness } = businessUnitsSlice.actions;

export default businessUnitsSlice.reducer;
